// @flow
import * as React from 'react';
import styled from 'styled-components';
import { FlexPlayerDemo } from '../../../styles';
import type { StatsRadioPlayerThemeData } from '../../../../domain/PlayerConfiguration';

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 1;
  height: 100%;
  cursor: pointer;

  i {
      font-size: 64px;
  }
`;

type Props = {
  data: StatsRadioPlayerThemeData,
}

export default function (props: Props) {
  return (
    <FlexPlayerDemo
      className="row"
      style={props.data.backgroundImage
        ? { backgroundImage: `url("${props.data.backgroundImage.preview || props.data.backgroundImage}")`, backgroundPosition: props.data.backgroundImagePosition }
        : { backgroundColor: props.data.backgroundColor }}
    >
      <IconContainer>
        <i className="material-icons" style={{ color: 'white' }}>play_circle_outline</i>
      </IconContainer>
    </FlexPlayerDemo>
  );
}




// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/demos/BannerDemo.js